<div (click)="this.close($event)"
     class="modal bg-black/50 flex items-center justify-center overflow-hidden clickClose p-2 fg-noir-1"
     style="z-index: 99999; position: fixed">
  <div class="bg-white border border-gris-2 w-full h-fit max-h-[650px] max-w-[500px] rounded flex flex-col fadeIn p-2 z-50 relative">
    <span class="w-fit absolute material-icons cursor-pointer hover:fg-orange-1 transition" (click)="this.modalService.close()">
      close
    </span>
    <p class="w-full text-center py-2 font-semibold fg-noir-1 border-b border-gris-3 mb-4 pb-4 flex items-center gap-2 justify-center">
      <span class="material-icons">campaign</span>
      <span>Message du restaurant</span>
    </p>

    <div class="w-full bg-gray-100 border border-gris-3 p-4 rounded font-medium ">
      <p class="w-full">{{this.message}}</p>
    </div>

    <div class="w-full mt-4 relative">
      <div class="border-b border-4 border-gris-3 rounded-full w-full"></div>
      <div class="border-b border-4 border-vert-1 rounded-full absolute top-0" [style.width]="this.animatedWidthPercentage + '%'"></div>
    </div>
  </div>
</div>
